import { Mail, MapPin, Phone, Clock3 } from "lucide-react";
import SEO from "../lib/seo";
import PageHero from "../components/PageHero";
import Reveal from "../components/Reveal";
import EnquiryForm from "../components/EnquiryForm";
import SectionHead from "../components/SectionHead";
import { COMPANY } from "../data/site";

export default function Contact() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: "Aviokan Technologies Private Limited",
    email: COMPANY.email,
    telephone: COMPANY.phone,
    address: {
      "@type": "PostalAddress",
      streetAddress: "B-128, First Floor, Sector 2",
      addressLocality: "Noida",
      addressRegion: "Uttar Pradesh",
      postalCode: "201301",
      addressCountry: "IN",
    },
  };
  return (
    <div data-testid="contact-page">
      <SEO title="Contact" description="Talk to an Aviokan expert — request a consultation for IT infrastructure, networking, cybersecurity, cloud, collaboration, digital engineering or managed IT services." path="/contact" jsonLd={jsonLd} />

      <PageHero
        eyebrow="CONTACT"
        title={"Talk to an expert."}
        desc="Request a consultation — tell us about your environment and requirement, and the right Aviokan consultant will respond within one business day."
        breadcrumb={[{ label: "Home", to: "/" }, { label: "Contact" }]}
        image="/images/contact/hero.jpg"
      />

      <section className="bg-[#F6F8FA] py-20" data-testid="contact-section">
        <div className="mx-auto max-w-[1320px] px-5 md:px-10 grid lg:grid-cols-[0.75fr_1.25fr] gap-10 items-start">
          <Reveal>
            <div className="space-y-4">
              <div className="relative overflow-hidden border border-[#E2E7EF]" data-testid="contact-hero-image">
                <img src="/images/contact/hero.jpg" alt="Aviokan technology specialist at work" className="h-40 w-full object-cover" loading="lazy" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#14151A]/85 via-transparent to-transparent" />
                <p className="absolute bottom-3 left-4 text-[11px] font-tech tracking-[0.25em] text-cy">ALWAYS ON — RESPONSES WITHIN ONE BUSINESS DAY</p>
              </div>
              <div className="border border-[#E2E7EF] bg-white p-7" data-testid="contact-address-card">
                <MapPin size={18} className="text-[#0089A1]" />
                <h2 className="font-display font-bold text-[#101828] mt-4">Registered office</h2>
                <p className="text-sm text-mist/65 leading-relaxed mt-2.5">{COMPANY.address}</p>
              </div>
              <a href={`mailto:${COMPANY.email}`} className="block border border-[#E2E7EF] bg-white p-7 hover:border-cy/45 transition-colors" data-testid="contact-email-card">
                <Mail size={18} className="text-[#0089A1]" />
                <h2 className="font-display font-bold text-[#101828] mt-4">Email</h2>
                <p className="text-sm text-mist/65 mt-2.5">{COMPANY.email}</p>
              </a>
              <a href={`tel:${COMPANY.phoneHref}`} className="block border border-[#E2E7EF] bg-white p-7 hover:border-cy/45 transition-colors" data-testid="contact-phone-card">
                <Phone size={18} className="text-[#0089A1]" />
                <h2 className="font-display font-bold text-[#101828] mt-4">Phone</h2>
                <p className="text-sm text-mist/65 mt-2.5">{COMPANY.phone}</p>
              </a>
              <div className="border border-ember/30 bg-ember/5 p-7" data-testid="contact-response-note">
                <Clock3 size={18} className="text-ember" />
                <p className="text-sm text-mist/75 leading-relaxed mt-3.5">Consultation requests are answered within one business day. For urgent incidents, mention “urgent” in your message.</p>
              </div>
            </div>
          </Reveal>
          <Reveal delay={0.12}>
            <div className="border border-[#E2E7EF] bg-white p-7 md:p-10">
              <h2 className="font-display font-black text-2xl text-[#101828] mb-8">Request a Consultation</h2>
              <EnquiryForm />
            </div>
          </Reveal>
        </div>
      </section>

      <section className="bg-[#EEF2F7] border-t border-[#E2E7EF]" data-testid="contact-map-section">
        <div className="mx-auto max-w-[1320px] px-5 md:px-10 py-16">
          <SectionHead index="03" eyebrow="Find us" title="Sector 2, Noida." lead="Visits by appointment — book a slot and a consultant will walk you through the labs and the NOC floor." className="mb-8" />
          <Reveal>
            <div className="border border-[#E2E7EF] p-2" data-testid="contact-map">
              <iframe
                title="Aviokan Technologies office location — Sector 2, Noida"
                src={COMPANY.mapsEmbed}
                width="100%"
                height="420"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                className="block"
                style={{ border: 0 }}
              />
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
